import text from './resources/locale/en.json';

class DataError {
    $onInit() {
        this.text = text;
    }
}

export default DataError;
